export default __webpack_public_path__ + "static/media/Text(bid).6f0d2689.svg";